// The location bar under the panel's header, on a brand with several locations (D4). Wording from the Amigo design's
// copy sheet (Location bar).
export default {
  label: 'Standort',
  all_one: 'Alle {{count}} Standorte',
  all_other: 'Alle {{count}} Standorte',
};
